import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAuth0 } from '@auth0/auth0-angular';
import { AUTH0_WRAPPER_CONFIG, authInterceptor } from '@auth/bp-pf-auth';
import { ApplicationConfig } from '@angular/core';
import { auth0WrapperConfig, authConfig } from './modules/auth/auth0-config/auth0-config';
import { supportLibConfig } from './modules/auth/auth0-config/support-config';
import { SUPPORT_LIB_CONFIG } from '@support/bp-pf-support';


export const appConfig: ApplicationConfig = {
  providers: [provideAnimations(),

    provideRouter(routes),
    // provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAuth0(authConfig.Auth0Data),
    { provide: AUTH0_WRAPPER_CONFIG, useValue: auth0WrapperConfig },
    { provide: SUPPORT_LIB_CONFIG, useValue: supportLibConfig },
    provideToastr(),
  ]
};

